module.exports = __webpack_public_path__ + "img/e.8cf9e470.jpg";